import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextField from 'components/TextField/TextField';
import {
  CODE,
  NAME,
  UNIQUE_IDENTIFIER,
} from 'constants/formFields';

import type { IBasicCustomerInfo } from '../interfaces/IBasicCustomerInfo';

import styles from '../sass/CreateCustomerView.module.scss';

function BasicCustomerInfo({
  control,
  placeholder,
  recordId,
  isUniqueIdentifierEditable = false,
}: IBasicCustomerInfo) {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.wrapper}>
        <Controller
          control={control}
          name={NAME}
          render={({
            field: {
              name,
              value,
              onChange,
            },
            fieldState: { error },
          }) => (
            <TextField
              name={name}
              value={value}
              label={t('customers.fields.customerName')}
              error={error?.message}
              onChange={(event) => onChange(event.target.value)}
              required
              placeholder={placeholder || t('customers.fields.customerName')}
            />
          )}
        />
        <Controller
          control={control}
          name={UNIQUE_IDENTIFIER}
          render={({
            field: {
              name,
              value,
              onChange,
            },
            fieldState: { error },
          }) => (
            <TextField
              name={name}
              value={value}
              label={t('customers.fields.uniqueIdentifier')}
              error={error?.message}
              onChange={(event) => onChange(event.target.value)}
              required
              placeholder={placeholder || t('customers.fields.uniqueIdentifier')}
              disabled={!!recordId && !isUniqueIdentifierEditable}
            />
          )}
        />
      </div>
      <div className={styles.wrapper}>
        <Controller
          control={control}
          name={CODE}
          render={({
            field: {
              name,
              value,
              onChange,
            },
            fieldState: { error },
          }) => (
            <TextField
              name={name}
              value={value}
              label={t('customers.fields.customerCode')}
              error={error?.message}
              onChange={(event) => onChange(event.target.value)}
              required
              placeholder={placeholder || t('customers.fields.customerCode')}
            />
          )}
        />
      </div>
    </>
  );
}

export default BasicCustomerInfo;
